import { createApi } from '@reduxjs/toolkit/query/react';
import reducerPath from '../../../app/reducerPath';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../baseQueryWithReAuth/baseQueryWithReAuth';
import HttpMethods from '../../../shared/api/HttpMethods';
import checkStatus from '../../../shared/http/checkStatus';
import config from '../../../shared/api/config';

const OAUTH = 'OAUTH';

export const oAuthApi = createApi({
  reducerPath: `${reducerPath.oauth2Resource}/api`,
  tagTypes: [OAUTH],

  baseQuery: (...args) => baseQueryWithReAuth(...args, `${config.oauth}`),

  endpoints: (builder) => ({
    getClient: builder.query({
      query: ({ clientId, params }) => ({
        params,
        url: `/clients/${clientId}`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
      providesTags: [OAUTH],
    }),
  }),
});

export const { useGetClientQuery } = oAuthApi;
